import { ReactNode } from 'react';

import { useFeatures } from '@/context/FeatureContext';
import NotFound from '@/pages/NotFound';

/** Render a route only while its feature flag is on; otherwise it does not exist. */
export const FeatureGate = ({
  feature,
  children,
}: {
  feature:
    | 'findings_inbox'
    | 'mia_review'
    | 'gold_set_queue'
    | 'food_mappings'
    | 'datasets'
    | 'feast'
    | 'annotator_workflow'
    | 'coverage_dashboard'
    | 'daily_sample';
  children: ReactNode;
}) => {
  const features = useFeatures();
  if (!features[feature]) {
    return <NotFound />;
  }
  return children;
};
